import { CLEAR_DETAIL, GET_DETAIL_RICH_COUNT, GET_DETAIL_TX_COUNT } from './mutation-types';
import MosaicProxy from '../../../proxies/MosaicProxy';


const get_count_info = async (context) => {
  const mosaics_proxy = new MosaicProxy();
  const richCount = await mosaics_proxy.get_mosaic_rich_count(context.rootState.route.params.id);
  const totalTX = await mosaics_proxy.mosaic_tx_count(context.rootState.route.params.id);
  context.commit(GET_DETAIL_TX_COUNT, totalTX);
  context.commit(GET_DETAIL_RICH_COUNT, richCount);

  return {
    richCount,
    totalTX
  };
};

const clear_count_info = async (context) => {
  context.commit(CLEAR_DETAIL);

};

export default {
  get_count_info,
  clear_count_info
};
